import { dom, library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { fas as fpas } from '@fortawesome/pro-solid-svg-icons';
import { far as fpar } from '@fortawesome/pro-regular-svg-icons';
import { fal as fpal } from '@fortawesome/pro-light-svg-icons';
import { fat as fpat } from '@fortawesome/pro-thin-svg-icons';
import { fad as fpad } from '@fortawesome/pro-duotone-svg-icons';

library.add(fas, far, fab, fpas, fpar, fpal, fpat, fpad);

dom.watch();
